"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _coordinates = require("./js/coordinates");
var _vuex = require("vuex");
var _dataCard = _interopRequireDefault(require("@/views/common/dataCard"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "dashboard",
  components: {
    dataCard: _dataCard.default
  },
  data: function data() {
    return {
      data: {},
      coordinatesJS: (0, _coordinates.dataInJs)(),
      returnCountry: [],
      orgGroup: this.$store.getters.orgGroup
    };
  },
  created: function created() {},
  //调用
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    //页面关闭时清除定时器
    clearInterval(this.interval);
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(["name", "roles", "permission_routers", "addRouters"])),
  methods: {}
};